module.exports = "https://static.zego.com/_next/static/images/hero-ireland-taxi-freenow-landing-d9d21849d5d6e029c20c5d7b2f2bc3dc.jpg";